import i18n from './index.js'
export default {//阿拉伯语
  translateText: {
    shoppingcart: "عربة التسوق",
    loginorrefisterText: "تسجيل الدخول/التسجيل",
    logoutText: "خروج تسجيل الدخول",
    personcenterText: "مركز شخصي",
    placeholderText: "يرجى الاختيار",
    loginText: "تسجيل الدخول",
    registerText: "تسجيل",
    emailText: "صندوق البريد",
    pwdText: "كلمة المرور",
    forgetpwdText: "نسيت كلمة المرور؟",
    nameText: "من",
    surnameText: "اسم",
    mobileText: "الهاتف",
    setPwdText: "ضبط كلمة المرور",
    countryText: "البلدان",
    company: "شركة",
    birthday:"عيد ميلاد",
    yearText:"عام",
    mouthText:"/",
    dayText:"/",
    confirmpwdText: "تأكيد كلمة المرور",
    agreeText1: "لقد قرأت ووافقت",
    agreeText2: "شروط الاستخدام",
    agreeText3: "وما",
    agreeText4: "بيان الخصوصية",
    agreeText5: ")، ووافقت على أن يتم تجهيز جزء من معلوماتي الشخصية خارج البلد وفقا لبيان الخصوصية.",
    emailplaceholder: 'يرجى إدخال صندوق البريد',
    subscribetitleText: 'الاشتراك في رسالتنا الإخبارية',
    subscribeText: 'الاشتراك',
    shareToText: 'نتشارك',
    searchText: 'البحث',
    subtractmoneyText: "ستمائة كحد أقصى",
    magnanimitycouponText: "قسائم كبيرة تنتظرك للحصول عليها",
    drawText: "خذها الآن",
    discountText: "خصومات كثيرة",
    purchaseText: "شراء على الفور",
    composecouponText: "شراء الجمع",
    manyDiscountsText: "عرض أفضل",
    recommendtitleText: "أوصي لك",
    hotsaleproductyitleText: "مبيعات ساخنة",
    guessLiketitleText: "احزر؟",
    NoDataText: "عدد لا يحصى من الوثائق",
    appraiseText: "التقييم",
    certificate: "قسائم",
    collectText: "مجموعة",
    addCartText: "انضم إلى عربة التسوق",
    enterkeywordsText: "أدخل الكلمات الرئيسية",
    useNowText: "استخدم على الفور",
    vouchernoText: "رقم القسيمة",
    placeholderyearText:"اختر سنة",
    placeholdermouthText:"إختر لايت",
    placeholderdayText:"إختر اليوم",
    // 优惠券页面
    breadcrumbItemText1: 'الخارق',
    breadcrumbItemText2: 'المستوى',
    breadcrumbItemText3: 'كبير',
    breadcrumbItemText4: 'الرعاية',
    breadcrumbItemText5: ' ',
    magnanimitydrawText: 'قسائم كبيرة تنتظرك للحصول عليها',
    availablecouponstitleText: 'يمكن استخدام منتجات القسائم',
    drawbtnText: 'الحصول على',
    universalText: 'كل شيء',
    useText: 'استخدام',
    limitText: 'تقتصر',
    fullText: 'ممتلئة',
    subtractText: 'خفض',
    // 折扣
    discountitemText1: 'الخصم يستمر ,',
    discountitemText2: 'ثلاثمائة',
    // 组合
    commoditydiscountitemText1: 'شراء الجمع ,',
    commoditydiscountitemText2: 'عرض أفضل',
    combinedpriceText: 'سعر التجميع',
    economizeText: 'وفورات',
    buynowText: "شراء على الفور",
    // 产品
    ourproductsText: 'منتجاتنا',
    productcategoryText: 'فئات المنتجات',
    recommendtarText: 'أوصي',
    newText: 'العام …',
    salesvolumetarText: 'بيعت',
    pricetarText: 'أسعار',
    // 博客
    blogmanagementText: "مدونة ساخنة",
    latestblogsText: "أحدث مدونة",
    relatedrlogsText: "مدونة ذات صلة",
    priceIncreasecommentText: "تقديم تعليق",
    commentsectionTtxt: "قسم التعليق",
    participatingcommentsText: "المشاركة في التعليق",
    // 论坛
    postingText: "نشر المشاركات",
    topicsText: "موضوع",
    replyText: "الرد",
    viewText: "عرض",
    lastreplyText: "الرد الأخير",
    publishText: "إصدار",
    placeholdertypeText: "يرجى اختيار تصنيف المواضيع",
    placeholdertitleText: "يرجى إدخال العنوان",
    placeholdercontentsText: "يرجى إدخال المحتوى",
    fromtopicText: "من الموضوع:",
    firstfloor: "في الطابق الأول",
    floorText: "الطابق",
    fromText: "من:",
    postreplyText: "أرسل الرد",
    // 个人中心 - 我的订单
    myorderText: "طلبي",
    mycommentsText: "تعليقي",
    mycollectionText: "مجموعتي",
    couponText: "القسيمة",
    shippingaddressText: "عنوان التسليم",
    myPostText: "نصيحتي",
    personalinformationText: "معلومات شخصية",
    editText: "التحرير",
    allordersText: "كل الطلبات",
    unpaidText: "تنتظر الدفع",
    shippedText: "جاهزة",
    receivedText: "تنتظر التسليم",
    evaluatedText: "التقييم",
    baidText: "الدفع",
    completedText: "اكتمل",
    productinfText: "معلومات المنتج",
    unitpricethText: "الوحدة",
    quantitythText: "عدد",
    actualpaymentthText: "نقدا",
    transactionstatusthText: "حالة التبادل",
    operationthText: "تشغيل",
    ordernumberText: "رقم الطلب",
    orderdetailsText: "تفاصيل الطلب",
    cancelorderText: "إلغاء الطلب",
    confirmText: "تحديد",
    cancelText: "إلغاء",
    deleteordertitle: "تحديد حذف الطلب الحالي؟",
    successfultradeText: "الصفقة تمت",
    paymentText: "الدفع",
    confirmreceiptText: "تأكيد التسليم",
    nncommentText: 'لا تعليق',
    // 个人中心 - 我的评论
    productText: "المنتجات",
    productdetailText: "تفاصيل التقييم",
    replyblogText: "مدونة الرد:",
    //个人中心 - 收货地址
    addseliveryaddressText: "إضافة عنوان الاستلام",
    addaddresstitleText1: "تم حفظه",
    addaddresstitleText2: "عنوان واحد، يمكن الاحتفاظ به",
    addaddresstitleText3: "عنوان",
    defaultText: "افتراضي",
    consigneeText: "المرسل إليه:",
    addressText: "العنوان:",
    fulladdressText: "العنوان الكامل:",
    setdefaultText: "إفتراضي",
    mobilephoneText: "الهاتف:",
    viewmoreText: "انظر المزيد",
    replypostText: "الرد:",
    // 个人中心 - 个人信息
    nameLabel:"أسماء",
    sexlabel:"نوع الجنس",
    modifyavatarText:"تعديل الرأس",
    sexmanText:"الرجال",
    sexwomanText:"النساء",
    secrecyText:"السرية",
    replaceText:"استبدال",
    saveText:"حفظ",
    oldpasswordText:"الرمز الأصلي",
    newpasswordText:"رمز جديد",
    confirmpasswordText:"تأكيد كلمة المرور",
    opdpleasolderText:"يرجى إدخال كلمة المرور الأصلية",
    newpleasolderText:"يرجى إدخال كلمة المرور الجديدة",
    unboundText:"غير مقيد",
    bindingText:"ربط",
    unbindingText:"تحرير بوظيفته",
    // 个人中心-个人信息
    regionText:"في المنطقة",
    addconsigneleasolderText:"يرجى ملء اسم المرسل إليه",
    countrypleasolderText:"يرجى اختيار البلد",
    provinceleasolderText:"يرجى اختيار المحافظات",
    citypleasolderText:"اختر المدينة",
    areapleasolderText:"يرجى اختيار المنطقة",
    fulladdressTextpleasolderText:"يرجى إدخال العنوان المفصل",
    addconsignephoneleasolderText:"يرجى ملء رقم هاتف المرسل إليه",
    emailpleasolderText:"يرجى إدخال عنوان صندوق البريد",
    phoneText:'رقم الهاتف',
    uploadimgText:"رفع الصورة",
    updateuserface:"تعديل الرأس",
    uploadimgtitle1:"لدعم صور JPG و JPG و PNG.",
    uploadimgtitle2:"الحجم الموصى به: صورة بمقياس 200*200 أو بمقياس",
    updateemailText:"تعديل صندوق البريد",
    updatemobileText:"تعديل رقم الهاتف",
    dialogemailtitle:"عنوان البريد",
    dialogmobiletitle:"رقم الهاتف",
    dialogheadertitle:"ربط الدخول بحساب جينغ الخاص بك",
    continueText:"مواصلة",
    verificationinformation:"معلومات التحقق",
    verificationinformationTitle1:"لمزيد المتابعة، يرجى إكمال هذه الخطوة للتحقق. نحن في طريقنا",
    verificationinformationTitle2:"إرسال رمز التحقق. يرجى إدخال أدناه.",
    verificationcode:"رمز التحقق",
    newtitle:"الجديدة",
    dialognewmobiletitle:"أدخل رقم الهاتف المحمول الجديد للاتصال به. وانقر لتأكيد الاستبدال",
    confirmpbtnText:"تأكيد",
    titlecpuntryselect:"اختر بلدك",
    hotcountrytitle:"بلد ساخن",
    aboutusText:"بشأننا",
    // 订单详情
    havequestionsText:"سؤال",
    preferentialText:"التفضيلية",
    enquiryText:"عروض الأسعار",
    combinationdiscountText:"عرض الجمع",
    introduceText:"عرض",
    buyermycommentsText:"تعليق المشتري",
    starText:"النجوم",
    yourmailboxText:"صندوق البريد الخاص بك",
    placeholderquestionText:"يرجى كتابة سؤالك",
    uploadimglimtText:"يرجى رفع ملف JPG/GIF/PNG. لا يمكن أن يتجاوز حجم الصورة 2 ميغابايت.",
    submitbtnText:"تقديم",
    // 购物车
    selectText:"اختيار",
    tipscartsText:"المنتجات المختارة (باستثناء رسوم الشحن)",
    settlementText:"تسوية",
    selectallText:"اختيار كامل",
    amountText:"المبلغ",
    addtofavoritesText:"انضم إلى حافظة",
    havecollectedText:"تم جمعها",
    tipdelecteproduct:"تحديد حذف السلع الحالية؟",
    deleteText:"حذف",
    tipclearcart:"تأكد من تفريغ عربة التسوق؟",
    clearcartText:"إفراغ عربة التسوق",
    totalText:"مجموع",
    totaltipText:"السلع الأساسية (باستثناء رسوم الشحن):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_ar.js